import loadable from '@loadable/component'

export const L2SubNavigation = loadable(() => import('./L2SubNavigation'))
export const L2SubNavigationItem = loadable(
  () => import('./L2SubNavigationItem')
)
export const L2SubNavigationFeaturedPost = loadable(
  () => import('./L2SubNavigationFeaturedPost')
)

export type { L2SubNavigationProps } from './L2SubNavigation'
export type { L2SubNavigationItemProps } from './L2SubNavigationItem'
export type { L2SubNavigationFeaturedPostProps } from './L2SubNavigationFeaturedPost'
